<template>
  <div class="payment-container" v-frag>
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-2 mx-sm-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)" v-if="user && user.IDStB">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Pagos y Trámites Regulares</h1>
                <p class="text-caption grey--text text--darken-1 mb-0 d-none d-sm-block">Consulta y abono de conceptos arancelarios por sede</p>
                <p class="text-caption grey--text text--darken-1 mb-0 d-block d-sm-none">Trámites y pagos regulares</p>
              </div>
            </div>
            <v-icon size="44" color="primary" class="opacity-30 d-none d-sm-block">mdi-receipt-text-outline</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-2 mx-sm-4 mb-6" elevation="10">
          <div class="pa-4 pa-sm-6 content-area bg-light">
            
            <!-- Selector de Sede -->
            <v-card class="rounded-xl border-light pa-5 mb-6 bg-white" elevation="0">
              <div class="d-flex align-center mb-3">
                <v-avatar color="primary" size="36" class="mr-3">
                  <v-icon color="white" small>mdi-map-marker-radius</v-icon>
                </v-avatar>
                <div>
                  <div class="text-subtitle-1 font-weight-bold primary-text">Sede del Trámite</div>
                  <div class="text-caption grey--text">Selecciona la sede correspondiente para consultar tus conceptos</div>
                </div>
              </div>

              <v-select
                v-model="sede"
                :items="sedes"
                item-text="sede.Feriado"
                item-value="sede.IDF"
                placeholder="Selecciona la sede..."
                return-object
                outlined
                rounded
                dense
                color="primary"
                v-on:change="loadData"
                prepend-inner-icon="mdi-map-marker-outline"
                hide-details
                class="mt-2"
              ></v-select>
            </v-card>

            <!-- Lista de Pagos -->
            <div v-if="pagos.length > 0">
              <div class="d-flex align-center justify-space-between mb-4 px-1">
                <h2 class="text-h6 font-weight-bold primary-text d-flex align-center mb-0">
                  <v-icon color="primary" small class="mr-2">mdi-format-list-checks</v-icon>
                  Conceptos y Aranceles
                </h2>
                <v-chip small color="primary" outlined class="font-weight-bold">
                  {{ pagos.length }} {{ pagos.length === 1 ? 'concepto' : 'conceptos' }}
                </v-chip>
              </div>

              <v-row>
                <v-col cols="12" md="6" lg="6" v-for="(pagoData, pagoKey) in pagos" :key="pagoKey">
                  <v-card class="rounded-xl border-light hover-card h-100 d-flex flex-column bg-white overflow-hidden" elevation="0">
                    <div class="pa-4 flex-grow-1">
                      
                      <div class="d-flex justify-space-between align-start mb-2">
                        <v-chip small class="font-weight-bold" color="grey lighten-4" text-color="grey darken-2">
                          #{{ pagoData.IDF }}
                        </v-chip>
                        
                        <v-chip
                          small
                          :color="pagoData.pagado ? 'success lighten-5' : (pagoData.block ? 'grey lighten-4' : 'warning lighten-5')"
                          :text-color="pagoData.pagado ? 'success darken-2' : (pagoData.block ? 'grey darken-2' : 'warning darken-3')"
                          class="font-weight-bold"
                        >
                          <v-icon left small v-if="pagoData.pagado">mdi-check-circle</v-icon>
                          <v-icon left small v-else-if="pagoData.block">mdi-lock</v-icon>
                          <v-icon left small v-else>mdi-clock-outline</v-icon>
                          {{ pagoData.pagado ? 'Pagado' : (pagoData.block ? 'Bloqueado' : 'Pendiente') }}
                        </v-chip>
                      </div>

                      <h3 class="text-subtitle-1 font-weight-bold primary-text line-height-1 mt-3 mb-1">
                        {{ pagoData.Concepto }}
                      </h3>
                      
                      <div class="d-flex align-center mt-3 mb-2 gap-2">
                        <div class="text-h5 font-weight-black success--text text--darken-2 d-flex align-center">
                          <span class="text-caption mr-1 font-weight-bold">ARS</span>
                          ${{ pagoData.Monto }}
                        </div>
                      </div>

                      <v-divider class="my-3 border-light"></v-divider>

                      <div class="d-flex justify-space-between align-center text-caption">
                        <span class="grey--text font-weight-medium">Forma de pago:</span>
                        <span class="primary-text font-weight-bold">{{ pagoData.forma_de_pago_data ? pagoData.forma_de_pago_data.Nombre : '-' }}</span>
                      </div>
                      
                      <div class="d-flex justify-space-between align-center text-caption mt-1">
                        <span class="grey--text font-weight-medium">Último abono:</span>
                        <span class="primary-text font-weight-bold">{{ pagoData.ultimo_pago == '' ? '-' : pagoData.ultimo_pago }}</span>
                      </div>

                    </div>

                    <!-- Botón de Pago -->
                    <div class="px-4 py-3 bg-light border-top mt-auto">
                      <v-btn
                        v-if="!pagoData.pagado && !pagoData.block"
                        color="primary"
                        block
                        rounded
                        elevation="2"
                        class="shadow-premium font-weight-bold text-none"
                        @click="createCobranza(pagoData.IDF)"
                      >
                        <v-icon left>mdi-credit-card</v-icon> Pagar ahora
                      </v-btn>
                      
                      <v-btn
                        v-else-if="pagoData.pagado"
                        color="success"
                        block
                        rounded
                        outlined
                        disabled
                        class="font-weight-bold text-none"
                      >
                        <v-icon left>mdi-check-all</v-icon> Ya Abonado
                      </v-btn>

                      <v-btn
                        v-else
                        color="grey"
                        block
                        rounded
                        outlined
                        disabled
                        class="font-weight-bold text-none"
                      >
                        <v-icon left>mdi-lock-outline</v-icon> No disponible
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            
            <div v-else-if="sede && sede.sede && sede.sede.IDF && sedes.length > 0" class="text-center pa-10 bg-white rounded-xl mt-4 border-light">
              <v-avatar color="grey lighten-4" size="80" class="mb-4">
                <v-icon size="40" color="grey">mdi-inbox-outline</v-icon>
              </v-avatar>
              <h3 class="text-h6 grey--text text--darken-1 font-weight-bold">Sin pagos registrados</h3>
              <p class="text-body-2 grey--text mb-0">No encontramos trámites regulares pendientes asociados a esta sede.</p>
            </div>

            <div v-else class="text-center pa-10 bg-white rounded-xl mt-4 border-light">
              <v-avatar color="primary lighten-5" size="80" class="mb-4">
                <v-icon size="40" color="primary">mdi-map-marker-question-outline</v-icon>
              </v-avatar>
              <h3 class="text-subtitle-1 font-weight-bold primary-text">Selecciona una sede</h3>
              <p class="text-caption grey--text text--darken-1 mb-0">Elige la sede correspondiente para consultar tus aranceles regulares.</p>
            </div>

          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "PaymentRegular",
  components: {
    CardIeaAppMain,
  },

  data: function () {
    return {
      title: "Efectuar pago",
      sede: { text: '', value: '' },
      sedes: [],
      pagos: [],
      total: 0,
      items: [],
      urlPay: '',
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    async loadData() {
      if (!this.sede || !this.sede.sede || !this.sede.sede.IDF) return;
      this.$API
        .get({
          url: "alumno-pagos-regulares?alumno=" + this.user.IDStB + "&sede=" + this.sede.sede.IDF,
          data: {},
        })
        .then((res) => {
          this.pagos = Array.isArray(res) ? res : [];
        })
        .catch((err) => {
          console.error(err);
        });
    },

    colorText(pagoData) {
      if (pagoData.block) return { color: '#888' };
      if (pagoData.pagado) return { color: 'green' };
      return { color: 'black' };
    },

    canPay(pagoData) {
      return !pagoData.block && !pagoData.pagado;
    },

    changeTotal(pagoData, index) {
      pagoData.index = index;
      if (pagoData.check) {
        this.total += pagoData.precioAPagar;
      } else {
        this.total -= pagoData.precioAPagar;
      }
      const selecteds = this.pagos.items ? this.pagos.items.filter(d => d.check) : [];
      this.items = selecteds.map(value => ({ id: value.IDStB, monto: value.precioAPagar, index: value.index }));
    },

    async createCobranza(id) {
      const dataSend = {
        alumno: this.user.IDStB,
      };

      const url = "pago-concepto-regular/" + id;

      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          if (res.id) {
            this.pay(res);
          } else {
            alert('Pago en revisión');
          }
        });
    },

    async pay(res) {
      await this.$API
        .post({
          url: "alumno-pagos-regulares-pay/" + res.id,
          data: res
        }).then((resUrl) => {
          location.href = resUrl;
        });
    },
  },

  mounted() {
    if (this.user && this.user.IDStB) {
      this.$API
        .get({
          url: "alumno-sedes/" + this.user.IDStB,
          data: {},
        })
        .then((res) => {
          this.sedes = Array.isArray(res) ? res : [];
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.payment-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.content-area {
  border-radius: inherit;
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }

.hover-card {
  transition: all 0.3s ease;
}
.hover-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px -8px rgba(0, 0, 0, 0.08) !important;
}

.border-light { border: 1px solid rgba(0, 0, 0, 0.06) !important; }
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.06); }
.border-top { border-top: 1px solid rgba(0, 0, 0, 0.06); }

.shadow-premium {
  box-shadow: 0 8px 24px -6px rgba(25, 118, 210, 0.45) !important;
}

.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.gap-2 { gap: 8px; }
</style>
